import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { FormattedRelative } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Home.css';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { geolocated } from 'react-geolocated';
import { connect } from 'react-redux';

// Components
// import SearchForm from '../../components/Home/SearchForm';
import HomePresentation from '../presentation/Home/Home';

// Graphql
import getRecommendQuery from './getRecommend.graphql';
import { getByCategoryQ, topListingsQ } from './getByCategoryQ';

// Locale
import messages from '../../locale/messages';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import Modal from '../../components_new/Modal';
import Onboarding from '../../components_new/verification/Onboarding';
import { getp } from '../../helpers/getProp';

const pageGroups = [
  [84, 85],
  [88, 86, 74, 77],
  [87, 93, 76, 97],
  [92, 95, 96, 89],
];
@observer
class Homepage extends React.Component {
  @observable loadedPages = {};
  @observable closed = false;
  @observable results = {};
  static propTypes = {
    getRecommendData: PropTypes.shape({
      loading: PropTypes.bool,
      getRecommendData: PropTypes.array,
    }),
    getImagineData: PropTypes.shape({
      loading: PropTypes.bool,
      getImagineData: PropTypes.array,
    }),
    getWorkData: PropTypes.shape({
      loading: PropTypes.bool,
      getWorkData: PropTypes.array,
    }),
    getPlayData: PropTypes.shape({
      loading: PropTypes.bool,
      getPlayData: PropTypes.array,
    }),
    getCreateData: PropTypes.shape({
      loading: PropTypes.bool,
      getCreateData: PropTypes.array,
    }),
    getLiveData: PropTypes.shape({
      loading: PropTypes.bool,
      getLiveData: PropTypes.array,
    }),
    formatMessage: PropTypes.func,
  };

  static defaultProps = {
    getRecommendData: {
      loading: true,
    },
    getImagineData: {
      loading: true,
    },
    getWorkData: {
      loading: true,
    },
    getPlayData: {
      loading: true,
    },
    getCreateData: {
      loading: true,
    },
    getLiveData: {
      loading: true,
    },
  };

  state = {
    kw: '',
    loc: '',
    lat: 0,
    lng: 0,
  };

  componentDidUpdate() {
    if (
      !this.state.lat &&
      this.props.coords &&
      this.props.coords.latitude &&
      this.state.lat !== this.props.coords.latitude
    ) {
      this.setState({
        lat: this.props.coords.latitude,
        lng: this.props.coords.longitude,
      });
    }
  }

  submitSearch = () => {
    const { kw, loc, lat, lng } = this.state;
    if (typeof window !== 'undefined') {
      let locationStr = ``;
      if (loc) {
        locationStr += `address=${loc}`;
      } else if (lat && lng) {
        locationStr += `lat=${lat}&lng=${lng}`;
      }
      window.location.assign(`/s?${locationStr}&kw=${kw}`);
    }
  };

  @computed
  get categoryKeys() {
    return Object.keys(this.results);
  }

  loadMore = loadNum => {
    if (loadNum >= pageGroups.length || this.loadedPages[loadNum]) {
      return;
    }
    this.loadedPages[loadNum] = true;
    const { topListings } = this.props;
    topListings.fetchMore({
      variables: { categoryIds: pageGroups[loadNum] },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        const newListings = Object.assign({}, prev, fetchMoreResult);
        if (!newListings.TopListings) {
          newListings.TopListings = {};
        }
        // console.log(
        //   'prev',
        //   prev.TopListings.results.filter(x => x.id === 1175),
        // );

        if (this.categoryKeys.length === 0) {
          this.addResults(getp(prev, 'TopListings.results', []));
        }
        this.addResults(getp(fetchMoreResult, 'TopListings.results', []));

        return newListings;
      },
    });
  };

  @action.bound
  addResults(arr) {
    if (!arr || !arr.length) return;
    arr.forEach(itm => {
      if (!this.results[itm.category]) {
        this.results[itm.category] = [];
      }
      this.results[itm.category].push(Object.assign({}, itm));
    });
  }

  @action.bound
  onboardingCompleted() {
    //This is needed because redux isn't always updating
    this.closed = true;
  }

  render() {
    const { topListings, account } = this.props;
    const categories =
      this.categoryKeys.length > 0
        ? this.results
        : _.groupBy(
            getp(topListings, 'TopListings.results', []),
            category => category.category,
          );

    const searchParams = Object.assign({}, this.state);
    const userId = getp(account, 'userId');
    const isOnboarded = getp(account, 'isOnboarded');

    return (
      <div className={s.root}>
        <HomePresentation
          loadMore={this.loadMore}
          loading={topListings.loading}
          handleSearchChange={e => this.setState({ kw: e.target.value })}
          handleCityChange={e => this.setState({ loc: e.target.value })}
          submit={this.submitSearch}
          searchParams={searchParams}
          tools={categories && categories['86']}
          sporting={categories && categories['76']}
          electronics={categories && categories['85']}
          dvd={categories && categories['97']}
          
          clothing={categories && categories['74']}
          home={categories && categories['77']}
          garden={categories && categories['93']}
          outdoor={categories && categories['84']}
          party={categories && categories['88']}
          properties={categories && categories['92']}
          recreational={categories && categories['91']}
          toys={categories && categories['87']}
          music={categories && categories['96']}
          business={categories && categories['89']}
          misc={categories && categories['95']}
        />
        <Modal
          isOpen={categories && userId && !isOnboarded && !this.closed}
          maxWidth={388}
        >
          <Onboarding onCompleted={this.onboardingCompleted} />
        </Modal>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  connect(
    state => {
      return {
        account: state.account.data,
      };
    },
    {},
  ),
  geolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 10000,
  }),
  graphql(topListingsQ, {
    name: 'topListings',
    options: {
      variables: { categoryIds: [91] },
      ssr: false,
    },
  }),
)(Homepage);



// WEBPACK FOOTER //
// ./src/routes/home/Home.js